import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import {
  IWizItemRenderer,
  WizBaseCollector,
  WizEventManager
} from '@wizeoo/akm-component-lib';

import { ALK_EVENT_TYPE } from '../../../../model/enums';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { KeyPair } from '@wizeoo/akm-compute-lib';

/**
 * rendu des flows
 */
@Component({
  selector: 'generator-restriction-renderer',
  templateUrl: './generator-restriction.renderer.html',
})
export class GeneratorRestrictionRenderer implements IWizItemRenderer<null, KeyPair> {
  @HostBinding('style.width') forcedWidth = '100%';
  

  public data: KeyPair;

  @Input()
  owner: WizBaseCollector;
  
  public get fullLabel(): string {
    let result: string = '' + this.data.r + ' => ' + this.data.l;
    return result;
  }

  constructor(public elementRef: ElementRef) {}

  /** suppression d'un élément des zones de contenu */
  public doDelete(): void {
    this.owner.wizDataProvider.removeItem(this.data);
    WizEventManager.dispatchEvent(this.owner.elementRef, new AlkEvent(ALK_EVENT_TYPE.DELETE, this.data));
  }

  /** édition */
  public doEdit(): void {
    WizEventManager.dispatchEvent(this.owner.elementRef, new AlkEvent(ALK_EVENT_TYPE.EDIT, this.data));
  }
}
